import { IRootState } from '../../../../../store'
import { IMotorSensoryAssessmentState } from '../store/motoSensoryAssessment.types'

export const getMotorSensoryAssessmentSelector = (state: IRootState): IMotorSensoryAssessmentState =>
  state.motorSensoryAssessment
